/* unplugin-vue-components disabled */import script from "./DramaDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./DramaDetailPage.vue?vue&type=style&index=0&id=153ca279&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153ca279"]])

export default __exports__